import React from "react";
import styled from "@emotion/styled";
import { border } from "styled-system";

import Box from "./box";

const Img = styled.img`
  object-fit: contain;
  height: 100%;
  width: 100%;

  ${border};

  ${({ align }) =>
    align ? `object-position: ${align}` : `object-position: left`}
`;

const Image = ({ src, alt, border, align, ...rest }) => (
  <Box flex="none" {...rest}>
    <Img align={align} src={src} alt={alt} border={border} />
  </Box>
);

export default Image;
